import { useEffect, useRef, useCallback } from 'react';
import { api } from '@/lib/api';

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) outputArray[i] = rawData.charCodeAt(i);
  return outputArray;
}

export function usePushNotifications(user) {
  const subscribedRef = useRef(false);

  const subscribe = useCallback(async () => {
    if (!user || subscribedRef.current) return;
    if (!('serviceWorker' in navigator) || !('PushManager' in window)) return;

    try {
      const registration = await navigator.serviceWorker.ready;

      // Check existing subscription
      let subscription = await registration.pushManager.getSubscription();

      if (!subscription) {
        // Get VAPID key from backend
        const { public_key } = await api.get('/push/vapid-key');
        if (!public_key) return;

        const permission = await Notification.requestPermission();
        if (permission !== 'granted') return;

        subscription = await registration.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: urlBase64ToUint8Array(public_key)
        });
      }

      // Send subscription to backend
      await api.post('/push/subscribe', {
        subscription: subscription.toJSON()
      });

      subscribedRef.current = true;
    } catch (err) {
      console.error('Push subscription error:', err);
    }
  }, [user]);

  useEffect(() => {
    if (user) subscribe();
  }, [user, subscribe]);
}
